exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".form-control[readonly][data-v-30b1aaa8] {\n  background: #fff;\n  font-weight: bold;\n  color: #313745;\n}", ""]);

// exports
